<template>
    <div>
        <div class="unitList">
            <div class="unit-block"
                 :class="[item.is_try==0?'lock':'allow-active',item.is_pass==1?'green-active':'',item.is_pass==2?'green-active':'',]"
                 @click="unitMemoryClick(item)"
                 v-for="(item,index) in unitList"
                 :key="'b'+index">
                <div class="unit-btn" :class="item.is_try==0?'':'allow-active'">
                    <div>{{item.name}}</div>
                </div>
                <img v-if="item.is_try==0" class="lock-icon" src="../../../../assets/img/grammarTest/lock.png" alt="">
                <img v-if="item.is_pass==2&&item.is_try==1" class="lock-icon"
                     src="@/assets/img/grammarTest/perform.png" alt="">
            </div>
        </div>
        <dynamic-box
                :windowStatus="windowStatus"
                :data="studyStage.dataSource"
                :type="studyStage.type"
                @callBack="callBack">
        </dynamic-box>
    </div>
</template>
<script>
    import {getUnitList} from '@/api/grammar'
    import Lockr from 'lockr'
    import {mapGetters, mapMutations} from 'vuex';
    import dynamicBox from "../../templates/dynamicBox";

    export default {
        components: {dynamicBox},
        computed: {
            ...mapGetters(['studyStage'])
        },
        data() {
            return {
                courseId: '',//课程id
                unitList: [],//单元列表
                windowStatus: false,
            };
        },
        methods: {
            ...mapMutations(['CHANGE_STUDY_TYPE']),
            //获取单元列表
            getList() {
                this.courseId = this.$route.query.id
                let params = {
                    token: Lockr.get('token'),
                    grammar_curriculum_id: this.courseId,
                    type: 1,
                }
                getUnitList(params).then(res => {
                    this.unitList = res.data//单元列表
                })
            },
            unitMemoryClick(item) {
                if (item.is_try == 0) {
                    this.$alert('请先学完本单元所有语法', '提示', {
                        confirmButtonText: '确定'
                    });
                    return null
                }
                let data = {
                    title: '单元整体回忆',
                    type: 'yufa/yfOverallMemory',
                    dataSource: {
                        unit_id: item.id,
                    },
                    closeBtn: true,
                }
                this.windowStatus = true
                this.CHANGE_STUDY_TYPE(data)

            },
            // 动态组件回调
            callBack(data) {
                if (data.type == 'close') {
                    this.windowStatus = false;
                }
            },
        },
        created() {
            this.getList()
        },
    }
</script>

<style scoped lang='less'>
    .unitList {
        border: 1px solid #DEDEDE;
        margin: 0 10px;
        display: flex;
        flex-wrap: wrap;

        .unit-block {
            width: 18%;
            height: 70px;
            margin: 10px 1%;
            background: linear-gradient(270deg, rgba(255, 197, 103, 1) 0%, rgba(255, 157, 0, 1) 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            /*flex-direction: column;*/
            font-size: 19px;
            color: #fff;
            cursor: pointer;
            position: relative;
            transition: all .3s;
            overflow: hidden;
            position: relative;

            .unit-btn {
                flex: 1;
                transition: all .5s;

                > div {
                    height: 70px;
                    line-height: 70px;
                    text-align: center;
                }
            }

            .allow-active:hover {
                background: #FF640C;
            }

            .unit-hidden {
                margin-right: -35px;
                transition: all .5s;
                width: 35px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                > div {
                    width: 35px;
                    height: 35px;
                    transition: all .5s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                > div:hover {
                    background: #FF640C;
                }

                .video-icon {
                    width: 20px;
                    height: 20px;

                }

                .bell-icon {
                    width: 20px;
                    height: 20px;
                }
            }


        }
        .green-active {
            background: #00D8A0;
        }
        .allow-active:hover {
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

            .unit-hidden {
                margin-right: 0;
            }
        }

        .lock {
            background: #818181;
        }

        .lock:hover {
            background: #818181;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }

        .lock-icon {
            position: absolute;
            bottom: 5px;
            right: 5px;
            height: 25px;
            width: 25px;
        }
    }

</style>